module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel05_770_280_vi-cb04239dfe05b47f0ae02afd2e70c860.jpg";